// import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getCommentsQuery = (id) => {
    return axios.get(`${apiurl?.getComments}?PurchaseOrderId=${id}`);
};
const getVendorCommentsQuery = (id) => {
    return axios.get(`${apiurl?.getVendorComments}?PurchaseOrderId=${id}`);
};
const getComments = (id, isVendor) => {
    // return useQuery(['getComments'], () => getCommentsQuery(id));
    return isVendor ? getVendorCommentsQuery(id) : getCommentsQuery(id);
};

export default getComments;
